import React, { useState } from "react";
import { Button, Box, Typography, List, ListItem, ListItemText, Divider } from "@mui/material";
import EntityForm from "./EntityForm";

const Step2EntityBuilder = ({ entities, setEntities }) => {
    const [showEntityForm, setShowEntityForm] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null); // Track the entity being edited

    const addEntity = (entity) => {
        if (editingIndex !== null) {
            // Update an existing entity
            const updatedEntities = [...entities];
            updatedEntities[editingIndex] = entity;
            setEntities(updatedEntities);
        } else {
            // Add a new entity
            setEntities([...entities, entity]);
        }
        setShowEntityForm(false);
        setEditingIndex(null);
    };

    const removeEntity = (index) => {
        const updatedEntities = entities.filter((_, i) => i !== index);
        setEntities(updatedEntities);
    };

    const editEntity = (index) => {
        setEditingIndex(index);
        setShowEntityForm(true);
    };

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                Entities
            </Typography>
            <Divider sx={{ mb: 2 }} />
            {entities.length === 0 && (
                <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                    No entities added yet. Click "Add Entity" to create one.
                </Typography>
            )}
            {entities.map((entity, index) => (
                <Box key={index} sx={{ mb: 3, border: "1px solid #ccc", borderRadius: 2, p: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                        Name : {entity.name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                        Custom Keys: {entity.keys.length > 0 ? entity.keys.join(", ") : "None"}
                    </Typography>
                    {entity.isGeoLocated && (
                        <Typography variant="body2" color="textSecondary">
                            Geo-Location: {entity.geoType === "static" ? "Static" : "Dynamic"}
                        </Typography>
                    )}
                    <Typography variant="body2" sx={{ mt: 1, fontWeight: "bold" }}>
                        Sensors:
                    </Typography>
                    <List dense>
                        {entity.sensors.length > 0 ? (
                            entity.sensors.map((sensor, i) => (
                                <ListItem key={i}>
                                    <ListItemText primary={sensor.sensor_name} />
                                </ListItem>
                            ))
                        ) : (
                            <Typography variant="body2" color="textSecondary">
                                No sensors added.
                            </Typography>
                        )}
                    </List>
                    <Typography variant="body2" sx={{ mt: 1, fontWeight: "bold" }}>
                        Detections:
                    </Typography>
                    <List dense>
                        {entity.detections.length > 0 ? (
                            entity.detections.map((detection, i) => (
                                <ListItem key={i}>
                                    <ListItemText primary={detection.detection_name} />
                                </ListItem>
                            ))
                        ) : (
                            <Typography variant="body2" color="textSecondary">
                                No detections added.
                            </Typography>
                        )}
                    </List>
                    <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => editEntity(index)}
                        >
                            Edit
                        </Button>
                        <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            onClick={() => removeEntity(index)}
                        >
                            Remove
                        </Button>
                    </Box>
                </Box>
            ))}
            {showEntityForm ? (
                <EntityForm
                    onSave={addEntity}
                    onCancel={() => {
                        setShowEntityForm(false);
                        setEditingIndex(null);
                    }}
                    entity={editingIndex !== null ? entities[editingIndex] : null} // Pass entity for editing
                />
            ) : (
                <Button variant="contained" onClick={() => setShowEntityForm(true)}>
                    Add Entity
                </Button>
            )}
        </Box>
    );
};

export default Step2EntityBuilder;
